import React from "react";
import { Card, Typography, Tag, Empty } from "antd";
import { FlaskConical } from "lucide-react";

const { Title, Text, Paragraph } = Typography;

export const ABTestsPage: React.FC = () => {
  return (
    <div>
      <Title level={2}>Tests A/B</Title>
      <Text type="secondary" style={{ marginBottom: 24, display: "block" }}>
        Configurez et analysez des tests A/B sur votre plateforme
      </Text>

      <Card style={{ textAlign: "center", padding: "60px 0" }}>
        <Empty
          image={<FlaskConical size={64} color="#d9d9d9" />}
          imageStyle={{ height: 80 }}
          description={
            <div>
              <Title level={4} style={{ marginBottom: 8 }}>
                Fonctionnalité à venir
              </Title>
              <Paragraph type="secondary" style={{ maxWidth: 400, margin: "0 auto" }}>
                Le système de tests A/B est en cours de développement.
                Il vous permettra de créer des expériences, définir des variantes,
                suivre les métriques de conversion et déterminer les meilleures
                configurations pour votre plateforme de streaming.
              </Paragraph>
              <Tag color="processing" style={{ marginTop: 16 }}>
                En développement
              </Tag>
            </div>
          }
        />
      </Card>
    </div>
  );
};

export default ABTestsPage;
